import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef, useEffect } from "react";
const HtmlPreview = ({ content, className = "", }) => {
    const iframeRef = useRef(null);
    useEffect(() => {
        if (iframeRef.current && content) {
            const iframeDocument = iframeRef.current.contentDocument ||
                iframeRef.current.contentWindow?.document;
            // Clear the iframe content
            iframeDocument?.open();
            // Write the HTML content to the iframe
            iframeDocument?.write(content);
            // Close the document stream
            iframeDocument?.close();
            // Add event listeners to handle iframe height adjustment
            const resizeObserver = new ResizeObserver(() => {
                try {
                    // Adjust iframe height to match content
                    const height = iframeDocument?.body.scrollHeight;
                    if (iframeRef.current) {
                        iframeRef.current.style.height = `${height}px`;
                    }
                }
                catch (error) {
                    console.error("Error adjusting iframe height:", error);
                }
            });
            if (iframeDocument?.body) {
                resizeObserver.observe(iframeDocument.body);
            }
            // Clean up
            return () => {
                if (iframeDocument?.body) {
                    resizeObserver.disconnect();
                }
            };
        }
    }, [content]);
    return (_jsx("iframe", { ref: iframeRef, title: "HTML Content Preview", className: `w-full border-0 bg-white rounded-lg ${className}`, sandbox: "allow-same-origin", srcDoc: "" }));
};
const HtmlPreviewContained = ({ content, className = "", }) => {
    const containerRef = useRef(null);
    return (_jsx("div", { ref: containerRef, className: `p-4 bg-gray-50 rounded-lg overflow-auto ${className}`, style: {
            contain: "content",
            isolation: "isolate",
        }, children: _jsx("div", { className: "html-preview-content", dangerouslySetInnerHTML: { __html: content || "No content available" }, style: {
                all: "initial", // Reset all properties
                color: "initial",
                background: "initial",
            } }) }));
};
import Frame from "react-frame-component";
const HtmlPreview2 = ({ content = "", className = "" }) => {
    return (_jsx(Frame, { className: `w-full h-full flex-grow border-0 bg-white rounded-lg ${className}`, style: { flexGrow: 1 }, initialContent: `
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width, initial-scale=1">
            <style>
              body { margin: 0; padding: 0; }
            </style>
          </head>
          <body>
            <div id="mountHere"></div>
          </body>
        </html>
      `, mountTarget: "#mountHere", children: _jsx("div", { dangerouslySetInnerHTML: { __html: content || "No content available" } }) }));
};
export default HtmlPreview;
export { HtmlPreview, HtmlPreview2, HtmlPreviewContained };
